<template>
  <div>
    <validation-component
      ref="walletFormRef"
      :validation-condition="walletCondition">
    </validation-component>
  </div>
</template>

<script>
import { REQUIRED } from '@/components/validation/tool/validator';
import ValidationComponent from '@/components/validation/validation.vue';
import { COUNTRY_PHONE_CODE_MAP } from '@/views/transfer/api/options';

export default {
  components: { ValidationComponent },
  props: {
    contact: {
      type: Object,
      default: () => ({}),
    },
    txnFields: {
      type: Array,
      default: () => ([]),
    },
  },
  data() {
    return {
      walletCondition: [
        {
          key: 'walletType',
          name: 'message.contact.walletType',
          type: 'select',
          defValue: '',
          rule: [],
          isShowStar: true,
          validator: this.validateWalletType,
          changeValue: (value) => {
            if (value) {
              const walletTypeInfo = this.walletTypeList.filter(item => item.walletType === value)[0];
              const bankCountry = this.contact.bankCountry;
              if (bankCountry) {
                this.$refs.walletFormRef.getValidationItem('walletPhone').prepend = walletTypeInfo && walletTypeInfo.textType !== 'TEXT' && bankCountry ? COUNTRY_PHONE_CODE_MAP[bankCountry] : '';
              }
            }
          },
        },
        {
          key: 'walletPhone',
          name: 'message.contact.walletPhone',
          type: 'input',
          defValue: '',
          rule: [],
          isShowStar: true,
          // maxLength: 11,
          prepend: '',
          validator: this.validateWalletPhone,
          changeValue: (value) => {
            let v = value.match(/^\d*(\d{0,10})/g)[0];
            const walletData = this.$refs.walletFormRef.getFormJson();
            const walletType = walletData.walletType;
            if (walletType) {
              const walletTypeInfo = this.walletTypeList.filter(item => item.walletType === walletType)[0];
              if (walletTypeInfo && walletTypeInfo.textType === 'TEXT') {
                v = value;
              }
            }
            this.$refs.walletFormRef.setItemValue('walletPhone', v);
          },
        },
      ],
      walletTypeList: [],
    };
  },
  mounted() {
    this.initData();
  },
  methods: {
    async initData() {
      const walletForm = this.$refs.walletFormRef;
      const bankCountry = this.contact.bankCountry;
      walletForm.getValidationItem('walletPhone').prepend = COUNTRY_PHONE_CODE_MAP[bankCountry];

      for (let i = 0; i < this.txnFields.length; i++) {
        const key = this.txnFields[i].key;
        const field = this.txnFields[i].field;
        if (['walletType', 'walletPhone'].includes(key)) { // 钱包
          walletForm.setItemHide(key, field === 'N');
          walletForm.setItemRequire(key, field === 'Y');
        }
      }

      walletForm.assignmentFormValue({
        ...this.contact,
      });
    },
    validate() { // 静默校验避免出现错误提示
      const data = this.$refs.walletFormRef.getFormJson();
      for (let i = 0; i < this.walletCondition.length; i++) {
        const item = this.walletCondition[i];
        if (!item.isHide) {
          if (item.validator && !item.validator(null, data[item.key])) {
            return false;
          } else if (item.rule && item.rule.length && !data[item.key]) {
            return false;
          }
        }
      }
      return true;
    },
    getData() {
      return this.$refs.walletFormRef.getFormJson();
    },
    async getValidateData() {
      const walletFormValid = await this.$refs.walletFormRef.validateAsync();
      if (!walletFormValid) {
        return null;
      }
      return this.$refs.walletFormRef.getFormJson();
    },
    setWalletTypeOptions(options = []) {
      this.walletTypeList = options;
      this.$refs.walletFormRef.setValidationSelectOptions('walletType', options);
      const walletType = this.$refs.walletFormRef.getItemValue('walletType');
      for (let i = 0; i < options.length; i++) {
        if (options[i].value === walletType) {
          this.$refs.walletFormRef.getValidationItem('walletPhone').prepend = options[i].textType !== 'TEXT' ? COUNTRY_PHONE_CODE_MAP[this.contact.bankCountry] : '';
          return;
        }
      }
      this.$refs.walletFormRef.setItemValue('walletType', '');
    },
    isFieldRequired(key) {
      let required = false;
      for (let i = 0; i < this.txnFields.length; i++) {
        if (this.txnFields[i].key === key) {
          required = this.txnFields[i].field === 'Y';
          break;
        }
      }
      return required;
    },
    validateWalletType(rule, value, callback = () => {}) {
      if (this.isFieldRequired('walletType') && (!value || REQUIRED.regExp.test(value))) {
        callback(new Error(this.$t('message.validator.required')));
        return false;
      }
      callback();
      return true;
    },
    validateWalletPhone(rule, value, callback = () => {}) {
      if (this.isFieldRequired('walletPhone') && (!value || REQUIRED.regExp.test(value))) {
        callback(new Error(this.$t('message.validator.required')));
        return false;
      }
      callback();
      return true;
    },
  },
};
</script>

<style>

</style>
